import { Stack, Card, Heading } from "@twilio/flex-ui/node_modules/@twilio-paste/core";
import { InvitedParticipantDetails } from "../../../types/InvitedParticipantDetails";
import { InvitedParticipant } from "./InvitedParticipant/InvitedParticipant";

interface InvitedParticipantsProps {
  invitedParticipantDetails: InvitedParticipantDetails[];
  handleCancelInvite: (invitedParticipantDetails: InvitedParticipantDetails) => void;
}

export const InvitedParticipants = ({ invitedParticipantDetails, handleCancelInvite }: InvitedParticipantsProps) => {
  const invitedParticipants = invitedParticipantDetails.map((invitedParticipantDetail, index) => {
    const participantName = invitedParticipantDetail.targetName;
    const { inviteTargetType } = invitedParticipantDetail;
    return (
      <InvitedParticipant
        key={index}
        participantName={participantName}
        inviteTargetType={inviteTargetType}
        handleCancelInvite={() => handleCancelInvite(invitedParticipantDetail)}
      />
    );
  });

  return (
    <Card padding="space60">
      <Heading as="h2" variant="heading20">
        Invited Participants
      </Heading>
      <Stack orientation="vertical" spacing="space20">
        {invitedParticipants}
      </Stack>
    </Card>
  );
};
